
import { RouterManagerService } from './service/managers/router-manager.service';
import { Router } from '@angular/router';
import { StorageService } from './service/managers/storage.service';

export function isAuthorized(permissions: string[], operation: string) {
  var routerManager = new RouterManagerService(null, new StorageService());
  var visible;
  var invisible;

  routerManager.restrictThroughPermissions(permissions, operation);

  visible = {};
  invisible = { hidden: true };

  if (routerManager.arePermissionsAuthorized()) {
    return visible;
  }

  return invisible;
}

export const navItems =
  [
    {
      name: 'Home',
      url: '/smsblast',
      icon: 'icon-home',
      badge: {
        variant: 'info',
        // text: 'NEW'
      }
    },

    {
      name: 'Permissions',
      icon: 'icon-lock-open',
      url: '/joytogive/permissions',
      attributes: isAuthorized(['create-users', 'view-permissions'], 'allowAny'),
    },
    {
      name: 'Roles',
      icon: 'icon-badge',
      url: '/joytogive/roles',
      attributes: isAuthorized(['create-users', 'view-permissions'], 'allowAny'),
    },

    {
      name: 'Users',
      icon: 'icon-people',
      url: '/joytogive/users_home',
      attributes: isAuthorized(['create-users', 'view-permissions'], 'allowAny'),
    },
    // {
    //   name: 'Messages',
    //   icon: 'icon-bubbles',
    //   url: '/joytogive/messages',
    // },
    {
      name: 'Contacts',
      icon: 'icon-notebook',
      url: '/joytogive/contacts',
    }
    // {
    //   name: 'SAMPLE NODE WITH NOTIF A',
    //   url: '/widgets',
    //   badge: {
    //     variant: 'info',
    //     text: 'NEW'
    //   }
    // },
    // {
    //   name: 'SAMPLE NODE WITH NOTIF B',
    //   url: '/dashboard',
    //   badge: {
    //     variant: 'secondary',
    //     text: 'NEW'
    //   },
    //   attributes: { disabled: true },
    // },
  ];